import React from 'react';
import './App.css';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import theme from "./theme";
import Home from "./components/Home";
import Dashboard from './components/Dashboard/Dashboard';
import InvitePage from './components/InvitePage';
import ResetPasswordPage from './components/ResetPasswordPage';
import VerifyEmailPage from './components/VerifyEmailPage';
import Settings from './components/Setting/Settings';
import SpotifyRedirect from './components/Setting/SpotifyRedirect';
import RequireAuth from './components/general/RequireAuth';
import CookieNotice from './components/general/CookieNotice';
import { AuthProvider } from './services/auth';

function App() {
  return (
    <CookiesProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <AuthProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<Home />} />
              {/* Public on purpose - an invite recipient usually isn't signed in yet,
                  and RequireAuth would redirect the token away. The page handles the
                  signed-out case itself. */}
              <Route path="/invite/:token" element={<InvitePage />} />
              {/* Both public for the same reason as the invite route: these links are
                  opened from an email, usually with no session. */}
              <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
              <Route path="/verify-email/:token" element={<VerifyEmailPage />} />
              <Route element={<RequireAuth />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/settings" element={<Settings />} />
                <Route path="/dashboard/settings/spotify-redirect" element={<SpotifyRedirect />} />
              </Route>
              {/* Anything unrecognised goes to the landing page rather than
                  rendering a blank screen with no matched route. */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <CookieNotice />
          </div>
          </AuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </CookiesProvider>
  );
}

export default App;
